import React, { FC } from 'react';
import './Result.scss';
import { IResultProps } from './IResultProps';
import LaereplanResultCard from '../../../SharedComponents/ResultCard/LaereplanResultCard';

const Result: FC<IResultProps> = (props) => {
    return <LaereplanResultCard result={props.result} idx={props.idx} />;
}

export default Result;

